import React from 'react';
import { Link } from 'react-router-dom';
import { SERVICE_CATALOG, getServiceStartingPriceValue, serviceFormHref } from '../mock';
import { useLanguage } from '../i18n/LanguageContext';
import { serviceTitle } from '../i18n/serviceCopy';

const pillClass =
  'shrink-0 inline-flex items-center gap-3 rounded-full border border-[#14A098]/18 bg-white pl-1.5 pr-5 py-1.5 shadow-sm shadow-[#14A098]/6 transition-colors';

const pillInteractive =
  'hover:border-[#14A098]/45 hover:bg-teal-50/80 hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#14A098]/40 focus-visible:ring-offset-2';

/**
 * Infinite horizontal strip (right-to-left) of all catalog services with icon badges.
 * Uses existing .marquee / .marquee-mask styles from App.css.
 * @param {{ linkable?: boolean }} props — when true, each pill navigates to that service's form
 */
export const ServiceMarquee = ({ linkable = false }) => {
  const { t } = useLanguage();
  const doubled = [...SERVICE_CATALOG, ...SERVICE_CATALOG];
  return (
    <div className="relative overflow-hidden rounded-2xl border border-[#14A098]/20 bg-gradient-to-r from-white/95 via-teal-50/50 to-cyan-50/40 py-3.5 shadow-[0_4px_24px_rgba(20,160,152,0.08)]">
      <div className="marquee-mask py-0.5">
        <div className="marquee marquee-left marquee-services items-center">
          {doubled.map((svc, idx) => {
            const Icon = svc.icon;
            const to = serviceFormHref(svc.code);
            const inner = (
              <>
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-[#14A098] to-[#0e8f87] text-white shadow-md ring-2 ring-white/40">
                  <Icon className="h-4 w-4" aria-hidden />
                </span>
                <span className="flex min-w-0 flex-col">
                  <span className="text-sm font-semibold tracking-tight text-[#0f2540] whitespace-nowrap">
                    {serviceTitle(svc.code, t, svc.title)}
                  </span>
                  <span className="text-xs font-semibold text-[#14A098] whitespace-nowrap">
                    {getServiceStartingPriceValue(svc.code)}
                  </span>
                </span>
              </>
            );
            return linkable ? (
              <Link
                key={`${svc.code}-${idx}`}
                to={to}
                className={`${pillClass} ${pillInteractive}`}
              >
                {inner}
              </Link>
            ) : (
              <div
                key={`${svc.code}-${idx}`}
                className={pillClass}
              >
                {inner}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
